<template>
  <div class="production_wrap">
    <!-- 图片全屏预览弹窗 -->
    <div v-if="showImagePreview" class="img-preview-mask" @click.self="closeImagePreview">
      <div class="img-preview-box">
        <!-- 关闭按钮 -->
        <span class="preview-close" @click.stop="closeImagePreview">×</span>

        <!-- 主体：左侧大图 + 右侧竖排缩略图 -->
        <div class="preview-main">
          <!-- 左侧大图区域 -->
          <div class="preview-big">
            <button class="preview-arrow prev" @click.stop="previewPrev">‹</button>
            <img :src="previewCurrentImg" alt="preview" />
            <button class="preview-arrow next" @click.stop="previewNext">›</button>
          </div>

          <!-- 右侧竖排缩略图 -->
          <div class="preview-thumb-wrap">
            <button class="thumb-arr top" @click.stop="previewPrev">↑</button>
            <div class="preview-thumb">
              <div
                  class="preview-thumb-item"
                  :class="{ active: previewCurrentImg === img }"
                  @click.stop="switchPreviewImg(img)"
                  v-for="img in allImages"
                  :key="img"
              >
                <img :src="img" alt="" />
              </div>
            </div>
            <button class="thumb-arr bottom" @click.stop="previewNext">↓</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗 -->
    <div v-if="showQuoteModal" class="quote-modal-mask">
      <div class="quote-modal">
        <!-- 关闭按钮 -->
        <div class="close-btn" @click="closeQuoteModal">×</div>

        <div class="quote-header">
          <h3>Get a Free Quote</h3>
          <p>Our representative will contact you soon.</p>
        </div>

        <div class="quote-body">
          <!-- Email -->
          <div class="form-item">
            <label>Email <span class="required">*</span></label>
            <input
                v-model="quoteForm.email"
                type="text"
                placeholder="Please enter your Email"
                maxlength="100"
                :class="{ invalid: formErrors.email }"
                @input="clearError('email')"
            />
            <div class="char-count">{{ quoteForm.email.length }}/100</div>
            <div class="error-tip" v-if="formErrors.email">{{ formErrors.email }}</div>
          </div>

          <!-- Name -->
          <div class="form-item">
            <label>Name</label>
            <input
                v-model="quoteForm.name"
                type="text"
                placeholder="Please enter your Name"
                maxlength="100"
                @input="clearError('name')"
            />
            <div class="char-count">{{ quoteForm.name.length }}/100</div>
          </div>

          <!-- Company Name -->
          <div class="form-item">
            <label>Company Name</label>
            <input
                v-model="quoteForm.company"
                type="text"
                placeholder="Please enter your Company Name"
                maxlength="200"
            />
            <div class="char-count">{{ quoteForm.company.length }}/200</div>
          </div>

          <!-- Message -->
          <div class="form-item">
            <label>Message <span class="required">*</span></label>
            <textarea
                v-model="quoteForm.message"
                placeholder="Please enter your Message"
                maxlength="1000"
                :class="{ invalid: formErrors.message }"
                @input="clearError('message')"
            ></textarea>
            <div class="char-count">{{ quoteForm.message.length }}/1000</div>
            <div class="error-tip" v-if="formErrors.message">{{ formErrors.message }}</div>
          </div>
        </div>

        <div class="quote-footer">
          <button class="submit-btn" @click="submitQuote">Submit</button>
        </div>
      </div>
    </div>

    <div
        class="production_img"
        v-if="hiddenProdFive1"
        :style="{ background: `url(${prodOne.image}) 0 0 no-repeat`, backgroundSize: '100%' }"
    >
      <div class="img_tit">{{ prodOne.title }}</div>
      <div class="img_desc">{{ prodOne.subtitle }}</div>
    </div>

    <div class="prod-container">
      <div class="left-menu">
        <div class="menu-title-box">
          <div class="menu-title">PRODUCTS</div>
          <div class="menu-toggle-btn" @click="menuCollapsed = !menuCollapsed">
            {{ menuCollapsed ? '+' : '×' }}
          </div>
        </div>

        <div class="menu-slide-box" :class="{ 'slide-close': menuCollapsed }">
          <div
              class="menu-item"
              :class="{ active: currentPath === item.routePath, last: index === productMenus.length-1 }"
              @click="goMenu(item)"
              v-for="(item, index) in productMenus"
              :key="item.id"
          >
            {{ item.menuName }}
          </div>
        </div>
      </div>

      <div class="right-content">
        <div v-if="!detail" class="loading">Loading details...</div>

        <div v-else>
          <div class="product-detail-wrap">
            <div class="img-wrap">
              <div class="detail-big-img">
                <button class="img-arrow left" @click="prevImg">‹</button>
                <div class="slider-wrapper">
                  <div class="slider-inner" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
                    <div class="slide-item" v-for="img in allImages" :key="img">
                      <img :src="img" alt="Product Image" @click="openImagePreview(img)"/>
                    </div>
                  </div>
                </div>
                <button class="img-arrow right" @click="nextImg">›</button>
              </div>
              <div class="thumb-control">
                <button class="thumb-btn" @click="prevImg">‹</button>
                <div class="thumb-list">
                  <div
                      class="thumb-item"
                      :class="{ active: currentImage === img }"
                      @click="switchImg(img)"
                      v-for="img in allImages"
                      :key="img"
                  >
                    <img :src="img" alt="Thumb" />
                  </div>
                </div>
                <button class="thumb-btn" @click="nextImg">›</button>
              </div>
            </div>

            <div class="detail-info">
              <h2 class="detail-name">{{ detail.productName }}</h2>
              <button class="quote-btn" @click="openQuoteModal">GET A QUOTE</button>
            </div>
          </div>

          <!-- ====================== Product Parameters ====================== -->
          <div class="params-section" v-if="detail.paramsImages && detail.paramsImages.length">
            <div class="tab-title-group" ref="tabParamsRef">
              <div class="tab-item active" @click="scrollToSection('tabParamsRef')">
                <span><img src="@/assets/param.png" style="width:18px;height:18px;object-fit:contain"></span> Product Parameters
              </div>
              <div style="flex:1"></div>
              <div class="tab-item" @click="scrollToSection('relatedRef')">
                Related Products
              </div>
            </div>

            <div class="params-image-vertical">
              <div class="param-img-vertical-item" v-for="(img, idx) in detail.paramsImages" :key="idx">
                <img :src="img" alt="Param Image" />
              </div>
            </div>
          </div>

          <!-- ====================== Specification ====================== -->
          <div class="params-section" v-if="detail.params && detail.params.length">
            <h3 class="section-title active" ref="tabSpecRef" @click="scrollToSection('tabSpecRef')">
              <div class="section-title-inner">
                <span><img src="@/assets/param.png" style="width:18px;height:18px;object-fit:contain"></span> Specification
              </div>
            </h3>
            <div class="text-params">
              <div class="param-item" v-for="(text, idx) in detail.params" :key="idx">
                {{ text }}
              </div>
            </div>
          </div>

          <!-- ====================== News & Blogs ====================== -->
          <div class="params-section" v-if="detail.productDetails">
            <h3 class="section-title active" ref="tabDetailRef" @click="scrollToSection('tabDetailRef')">
              <div class="section-title-inner">
                <span><img src="@/assets/param.png" style="width:18px;height:18px;object-fit:contain"></span> Product
                Details
              </div>
            </h3>
            <div class="param-item" style="white-space: pre-line; line-height: 1.7;">
              {{ detail.productDetails }}
            </div>
          </div>

          <!-- ====================== Related Products ====================== -->
          <div class="related-section" ref="relatedRef" v-if="relatedList && relatedList.length">
            <h3 class="section-title active" @click="scrollToSection('relatedRef')">
              <div class="section-title-inner">
                <span><img src="@/assets/param.png" style="width:18px;height:18px;object-fit:contain"></span> Related Products
              </div>
            </h3>
            <div class="related-slider-container">
              <button class="related-arrow left" @click="prevRelated" :disabled="relatedIndex <= 0">‹</button>
              <div class="related-slider-wrapper">
                <div class="related-slider-inner" :style="{
                  transform: isMobile
                    ? `translateX(-${relatedIndex * (isNarrow ? 100 : 50)}%)`
                    : `translateX(-${relatedIndex * 25.5}%)`
                }">
                  <div
                      class="product-card"
                      v-for="item in relatedList"
                      :key="item.productNo"
                      @click="goDetail(item.productNo)"
                  >
                    <div class="card-img"><img :src="item.mainImage" alt="" /></div>
                    <div class="card-name">{{ item.productName }}</div>
                  </div>
                </div>
              </div>
              <button
                  class="related-arrow right"
                  @click="nextRelated"
                  :disabled="isMobile ? (relatedIndex >= relatedList.length - 1) : (relatedIndex > relatedList.length - 4)"
              >›</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <CallMe />
  </div>
</template>

<script>
import CallMe from '@/components/callme/index'
import {leftLikeDict, getMenuFrontTree, getProductList, getProductDetail, getRelationProduct, getProductQuote} from '../../api/system'
import {findDictHidden, findMainProp} from '../../utils'

export default {
  data() {
    return {
      hiddenProdFive1: true,
      prodOne: {},
      productMenus: [],
      prodList: [],
      currentPath: '',
      menuCollapsed: true,
      detail: null,
      allImages: [],
      currentImage: '',
      currentIndex: 0,
      relatedList: [],
      relatedIndex: 0,
      isMobile: false,
      autoPlayTimer: null,
      isNarrow: false,
      // 弹窗表单
      showQuoteModal: false,
      showImagePreview: false,
      previewCurrentImg: '',
      quoteForm: {
        email: '',
        name: '',
        company: '',
        message: ''
      },
      formErrors: {}
    }
  },
  components: {
    CallMe,
  },
  mounted() {
    // 检测是否为移动端
    this.isMobile = window.innerWidth <= 768;
    this.isNarrow = window.innerWidth < 380;
    window.addEventListener('resize', () => {
      this.isMobile = window.innerWidth <= 768;
      this.isNarrow = window.innerWidth < 380;
    });
    // this.leftLikeDictFunc();
    this.getProductMenu();
    // this.getProductList();
    this.updateActiveMenu();
    this.getDetail();
    // 自动轮播（3秒一次）
    this.startAutoPlay();
  },
  watch: {
    $route() {
      this.updateActiveMenu();
      this.getDetail();
    },
    beforeDestroy() {
      this.clearAutoPlay();
    },
  },
  methods: {
    // 打开弹窗
    openQuoteModal() {
      this.showQuoteModal = true
      this.quoteForm = { email: '', name: '', company: '', message: '' }
      this.formErrors = {}
      document.body.style.overflow = 'hidden'
    },
    // 关闭弹窗
    closeQuoteModal() {
      this.showQuoteModal = false
      document.body.style.overflow = ''
    },
    // 清除错误
    clearError(field) {
      if (this.formErrors[field]) {
        this.formErrors[field] = ''
      }
    },
    // 提交表单
    async submitQuote() {
      this.formErrors = {}
      let valid = true

      // 邮箱校验
      if (!this.quoteForm.email.trim()) {
        this.formErrors.email = 'Please enter your Email'
        valid = false
      } else if (!/^[\w\.-]+@[\w\.-]+\.\w+$/.test(this.quoteForm.email)) {
        this.formErrors.email = 'Please enter a valid Email'
        valid = false
      }

      // 消息校验
      if (!this.quoteForm.message.trim()) {
        this.formErrors.message = 'Please enter your Message'
        valid = false
      }

      if (!valid) return

      // 组装JSON  + 加入 productNo
      const submitData = {
        ...this.quoteForm,
        productNo: this.$route.query.productNo || ''
      }
      const jsonStr = JSON.stringify(submitData)

      try {
        await getProductQuote(jsonStr)
        this.$message.success('Submitted successfully')
        this.closeQuoteModal()
      } catch (err) {
        this.$message.error('Submission failed, please try again')
      }
    },

    // ====================== 统一平滑滚动方法（已减去导航栏 56px） ======================
    scrollToSection(refName) {
      const el = this.$refs[refName]
      if (!el) return
      const navHeight = 56
      const targetTop = el.getBoundingClientRect().top + window.scrollY - navHeight
      const startTop = window.scrollY
      const distance = targetTop - startTop
      const duration = 700
      let startTime = null

      const animate = (time) => {
        if (!startTime) startTime = time
        const progress = time - startTime
        let ratio = Math.min(progress / duration, 1)
        ratio = 1 - Math.pow(1 - ratio, 3)
        window.scrollTo(0, startTop + distance * ratio)
        if (progress < duration) requestAnimationFrame(animate)
      }
      requestAnimationFrame(animate)
    },
    async getProductMenu() {
      try {
        const res = await getMenuFrontTree();
        if (res.data.code === 200) {
          const parent = res.data.data[1];
          this.productMenus = parent?.children || [];
        }
      } catch (e) {}
    },
    async getProductList() {
      try {
        const res = await getProductList("5");
        if (res.data.code === 200) {
          this.prodList = res.data.data || [];
        }
      } catch (e) {}
    },
    goMenu(item) {
      this.$router.push({path: item.routePath});
    },
    goDetail(productNo) {
      this.$router.push('/production/detail?productNo=' + productNo);
    },
    updateActiveMenu() {
      this.currentPath = this.$route.path;
    },
    async getDetail() {
      const productNo = this.$route.query.productNo;
      if (!productNo) return;
      try {
        const res = await getProductDetail(productNo);
        if (res.data.code === 200) {
          this.detail = res.data.data;
          this.allImages = [];
          if (this.detail.mainImage) this.allImages.push(this.detail.mainImage);
          if (this.detail.subImages && this.detail.subImages.length) {
            this.allImages = this.allImages.concat(this.detail.subImages);
          }
          if (this.allImages.length) {
            this.currentImage = this.allImages[0];
            this.currentIndex = 0;
          }
          // 加载对应类型banner
          if (this.detail.productType) {
            this.loadBannerByType(this.detail.productType)
          }
        }
        await this.getRelatedProducts(productNo);
      } catch (e) {
        console.error('Load detail failed');
      }
    },
    async getRelatedProducts(productNo) {
      try {
        const res = await getRelationProduct(productNo);
        if (res.data.code === 200) {
          this.relatedList = res.data.data || [];
        }
      } catch (e) {
        console.error('Load related failed');
      }
    },
    switchImg(img) {
      this.currentImage = img;
      this.currentIndex = this.allImages.indexOf(img);
    },
    prevImg() {
      if (!this.allImages.length) return;
      this.currentIndex = (this.currentIndex - 1 + this.allImages.length) % this.allImages.length;
      this.currentImage = this.allImages[this.currentIndex];
    },
    nextImg() {
      if (!this.allImages.length) return;
      this.currentIndex = (this.currentIndex + 1) % this.allImages.length;
      this.currentImage = this.allImages[this.currentIndex];
    },
    prevRelated() {
      if (!this.relatedList.length || this.relatedIndex <= 0) return;
      this.relatedIndex--;
    },
    nextRelated() {
      if (!this.relatedList.length) return;

      let maxIndex = this.isMobile
          ? this.relatedList.length - (this.isNarrow ? 1 : 2)
          : this.relatedList.length - 4;

      if (this.relatedIndex >= maxIndex) return;
      this.relatedIndex++;
    },
    // 根据 productType 动态获取顶部banner
    async loadBannerByType(productType) {
      try {
        const typeMap = {
          1: 'prod_one1',
          2: 'prod_two1',
          3: 'prod_three1',
          4: 'prod_four1',
          5: 'prod_five1',
          6: 'prod_six1',
          7: 'prod_seven1',
          8: 'prod_eight1',
          9: 'prod_nine1'
        }
        const dictKey = typeMap[productType] || 'prod_five1'
        const res = await leftLikeDict(dictKey)
        if (res.data) {
          this.prodOne = findMainProp(res.data.data, dictKey)
          this.hiddenProdFive1 = findDictHidden(dictKey, res.data.data)
        }
      } catch (e) {}
    },
    // 自动轮播（加在 methods 最后）
    startAutoPlay() {
      // 防止重复计时
      if (this.autoPlayTimer) clearInterval(this.autoPlayTimer);

      this.autoPlayTimer = setInterval(() => {
        if (!this.relatedList || this.relatedList.length <= 1) return;

        const total = this.relatedList.length;
        // 移动端判断
        if (this.isMobile) {
          let maxIndex = this.isNarrow ? total - 1 : total - 2;
          if (this.relatedIndex >= maxIndex) {
            this.relatedIndex = 0;
          } else {
            this.relatedIndex++;
          }
        } else {
          // 桌面端
          if (this.relatedIndex >= total - 4) {
            this.relatedIndex = 0;
          } else {
            this.relatedIndex++;
          }
        }
      }, 3000); // 3秒切换一次
    },

// 清除计时器
    clearAutoPlay() {
      if (this.autoPlayTimer) {
        clearInterval(this.autoPlayTimer);
        this.autoPlayTimer = null;
      }
    },
    // 打开预览
    openImagePreview(img) {
      this.showImagePreview = true;
      this.previewCurrentImg = img;
      document.body.style.overflow = 'hidden';
    },
    // 关闭预览
    closeImagePreview() {
      this.showImagePreview = false;
      document.body.style.overflow = '';
    },
    // 点击缩略图切换预览图
    switchPreviewImg(img) {
      this.previewCurrentImg = img;
    },
    // 预览上一张
    previewPrev() {
      const idx = this.allImages.indexOf(this.previewCurrentImg);
      let newIdx = idx - 1;
      if (newIdx < 0) newIdx = this.allImages.length - 1;
      this.previewCurrentImg = this.allImages[newIdx];
    },
    // 预览下一张
    previewNext() {
      const idx = this.allImages.indexOf(this.previewCurrentImg);
      let newIdx = idx + 1;
      if (newIdx >= this.allImages.length) newIdx = 0;
      this.previewCurrentImg = this.allImages[newIdx];
    }
  }
}
</script>

<style lang="scss" scoped>
/* 弹窗样式 */
.quote-modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.quote-modal {
  width: 600px;
  background: #fff;
  border-radius: 12px;
  padding: 32px;
  position: relative;
  max-height: 85vh;
  overflow-y: auto;
  @media (max-width: 768px) {
    width: 92%;
    padding: 20px;
  }
}
/* 关闭按钮 */
.close-btn {
  position: absolute;
  right: 25px;
  top: 25px;
  width: 32px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  font-size: 40px;
  color: #666;
  cursor: pointer;
  border-radius: 50%;
  &:hover {
    background: #f5f5f5;
    color: #000;
  }
}
.quote-header {
  text-align: center;
  margin-bottom: 28px;
  h3 {
    font-size: 26px;
    margin: 0 0 8px;
    color: #333;
  }
  p {
    font-size: 16px;
    color: #666;
    margin: 0;
  }
}
.quote-body {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.form-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  label {
    font-size: 16px;
    color: #333;
    font-weight: 500;
  }
  input, textarea {
    padding: 12px 14px;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 15px;
    outline: none;
    &:focus {
      border-color: #992667;
    }
  }
  textarea {
    min-height: 110px;
    max-height: 180px;
    resize: vertical;
    overflow-y: auto;
  }
  .invalid {
    border-color: #f53f3f;
  }
  .char-count {
    font-size: 13px;
    color: #999;
    text-align: right;
  }
  .error-tip {
    font-size: 13px;
    color: #f53f3f;
  }
}
.required {
  color: #f53f3f;
}
.quote-footer {
  margin-top: 28px;
  text-align: center;
}
.submit-btn {
  background: #992667;
  color: #fff;
  border: none;
  padding: 12px 36px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  &:hover {
    background: #7a1e52;
  }
}

/* 原有样式完全不变 */
.production_wrap {
  width: 100%;
  .production_img {
    width: 100%;
    height: 600px;
    @media screen and (max-width: 768px) {height: 50vw;}
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .img_tit {
      font-size: 60px;
      font-weight: bold;
      @media screen and (max-width: 768px) {font-size: 22px;}
    }
    .img_desc {
      font-size: 32px;
      margin-top: 20px;
      @media screen and (max-width: 768px) {font-size: 16px;}
    }
  }

  .prod-container {
    display: flex;
    width: 100%;
    max-width: 100%;
    margin: 40px 0;
    padding: 0 20px;
    gap: 20px;
    box-sizing: border-box;
    align-items: flex-start;
    @media (max-width: 768px) {
      flex-direction: column;
      padding: 0 15px;
      margin: 30px 0 0;
    }
  }

  .left-menu {
    width: 20%;
    border: 1px solid #eee;
    padding: 0;
    background: #fff;
    position: relative;
    z-index: 1;
    align-self: flex-start;
    font-family: 'Roboto_Bold', sans-serif;
    @media (max-width: 768px) {width: 100%;}
    .menu-title-box {
      background: #992667;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .menu-title {
        color: #fff;
        font-size: 22px;
        padding: 16px 20px;
        margin: 0;
        box-sizing: border-box;
        font-weight: bold;
        @media (max-width: 768px) {
          font-size: 18px;
          padding: 10px 20px;
        }
      }
      .menu-toggle-btn {
        color: #fff;
        font-size: 24px;
        font-weight: bold;
        padding: 16px 20px;
        cursor: pointer;
        user-select: none;
        display: none;
        @media (max-width: 768px) {
          display: block;
          font-size: 22px;
          padding: 10px 20px;
        }
      }
    }
    .menu-slide-box {
      max-height: 3000px;
      overflow: hidden;
      transition: max-height 0.4s ease-out;
    }
    .menu-slide-box:not(.slide-close) {max-height: 2200px;}
    .menu-slide-box.slide-close {
      @media (max-width: 768px) {max-height: 0;}
    }
    .menu-item {
      padding: 16px 20px;
      border-bottom: 1px solid #eee;
      font-size: 18px;
      cursor: pointer;
      transition: all 0.3s;
      color: #333;
      background: #fff;
      display: block;
      width: 100%;
      box-sizing: border-box;
      text-align: left;
      font-weight: bold;
      @media (max-width: 768px) {
        font-size: 15px;
        padding: 10px 20px;
      }
      &.last {border-bottom: none !important;}
      &:hover {background: #f8f8f8;}
      &.active {color: #992667;background: #fff;}
    }
  }

  .right-content {
    flex: 1;
    padding: 0;
    @media (max-width: 768px) {width: 100%;margin-top: 25px;}
  }
  .loading {padding: 40px;text-align: center;font-size: 16px;}
  .product-detail-wrap {
    width: 100%;
    background: #fff;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    gap: 20px;
    align-items: flex-start;
    @media (max-width: 768px) {flex-direction: column;}
  }
  .img-wrap {
    width: 50%;
    display: flex;
    flex-direction: column;
    gap: 12px;
    @media (max-width: 768px) {width: 100%;}
  }
  .detail-big-img {
    width: 100%;
    height: 650px;
    position: relative;
    overflow: hidden;
    background: transparent;
    .slider-wrapper {width: 100%;height: 100%;overflow: hidden;}
    .slider-inner {display: flex;height: 100%;transition: transform 0.3s ease-out;}
    .slide-item {
      flex-shrink: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      img {max-width: 100%;max-height: 100%;object-fit: contain;}
    }
    @media (max-width: 768px) {height: 380px;}
  }
  .img-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 60px;
    height: 60px;
    border: none;
    background: rgba(49, 47, 47, 0.96);
    color: #fff;
    font-size: 35px;
    cursor: pointer;
    z-index: 2;
    &.left {left: 10px;}
    &.right {right: 10px;}
    &:hover {background: #992667;}
  }
  .thumb-control {display: flex;align-items: center;gap: 8px;width: 100%;}
  .thumb-btn {
    flex-shrink: 0;
    width: 36px;
    height: 120px;
    background: #ffffff;
    color: #707072;
    border: none;
    font-size: 35px;
    cursor: pointer;
    border-radius: 4px;
    &:hover {color: #040000;}
  }
  .thumb-list {flex: 1;display: flex;gap: 10px;overflow-x: auto;}
  .thumb-item {
    width: 100px;
    height: 120px;
    flex-shrink: 0;
    border: 2px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
    img {width: 100%;height: 100%;object-fit: cover;}
    &.active {border-color: #992667;}
  }
  .detail-info {
    width: 35%;
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: flex-start;
    @media (max-width: 768px) {
      width: 100%;
      align-items: center;
      text-align: center;
    }
  }
  .detail-name {
    font-size: 36px;
    color: #000;
    margin: 40px 0 40px;
    font-weight: bold;
    font-family: 'Roboto_Bold', sans-serif;
  }
  .quote-btn {
    background: #992667;
    color: #fff;
    border: none;
    padding: 14px 36px;
    font-size: 16px;
    border-radius: 6px;
    cursor: pointer;
    font-weight: bold;
    transition: background 0.3s;
    font-family: 'Roboto', sans-serif;
    &:hover {background: #7a1e52;}
  }

  .tab-title-group {
    display: flex;
    align-items: center;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    padding: 14px 0;
    margin: 30px 0 15px;
  }
  .tab-item {
    font-size: 24px;
    font-weight: bold;
    color: #333;
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
    font-family: 'Roboto_Bold', sans-serif;
    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: -15px;
      width: 0;
      height: 3px;
      background: #992667;
      transition: width 0.3s ease;
    }
    &.active::after,
    &:hover::after {width: 100%;}
  }

  .params-image-vertical {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
  }
  .param-img-vertical-item {
    width: 100%;
    img {
      width: 100%;
      display: block;
      object-fit: contain;
      border-radius: 4px;
    }
  }
  .text-params {display: flex;flex-direction: column;gap: 8px;}
  .param-item {
    font-size: 20px;
    color: #0c0c0c;
    padding: 10px 12px;
    border-radius: 4px;
    font-family: 'Roboto', sans-serif;
  }
  .related-section {margin-top: 40px;position: relative;}

  .tab-item img,
  .section-title-inner img {
    width: 18px;
    height: 18px;
    object-fit: contain;
    vertical-align: middle;
  }
  @media (max-width: 768px) {
    .tab-item span,
    .section-title-inner span {
      margin-right: 6px;
    }
  }

  .section-title {
    font-size: 24px;
    font-weight: bold;
    margin: 30px 0 15px;
    color: #333;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    padding: 14px 0;
    position: relative;
    display: block;
    cursor: pointer;
    font-family: 'Roboto_Bold', sans-serif;

    .section-title-inner {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: -15px;
        width: 0;
        height: 3px;
        background: #992667;
        transition: width 0.3s ease;
      }
    }

    &.active .section-title-inner::after {
      width: 100%;
    }
  }
  .related-slider-container {
    display: flex;
    align-items: center;
    position: relative;
    gap: 10px;
    @media (max-width: 768px) {
      gap: 0;
    }
  }
  .related-slider-wrapper {
    flex: 1;
    overflow: hidden;
    padding: 0 6px;   /* 左右留安全空间，永远不切边框 */
    box-sizing: border-box;
  }
  .related-slider-inner {
    display: flex;
    transition: transform 0.4s ease-out;
    padding-top: 4px;
    //padding-right: 4px;
    box-sizing: border-box;
    align-items: stretch;
  }
  .product-card {
    flex-shrink: 0;
    width: 24%;
    margin-right: 1.33%;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    border: 1px solid #cecccc;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    transition: all 0.3s ease;
    height: 100%;
    min-height: 380px;

    @media (max-width: 768px) {
      border-radius: 0;
      width: 100% !important;
      border: none !important;
      box-shadow: none !important;
      margin: 0 !important;
      height: 100%;
      min-height: 320px;
    }
    @media (min-width: 380px) and (max-width: 768px) {
      width: 50% !important;
    }

    .card-img {
      width: 100%;
      height: 450px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;

      @media (max-width: 768px) {
        height: 280px !important;
        aspect-ratio: unset !important;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center;
        transition: all 0.4s ease;
      }
    }
    .card-name {
      width: 100%;
      height: 80px;
      flex-shrink: 0;
      background: #3a3d51;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 10px;
      font-size: 18px;
      text-align: center;
      transition: background 0.3s ease;
      box-sizing: border-box;
      font-weight: bold;
      font-family: 'Roboto', sans-serif;
      @media (max-width: 768px) {
        height: 35px;
        font-size: 15px;
        background: transparent !important;
        color: #333 !important;
      }
    }
    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
      .card-img img {transform: scale(1.05);}
      .card-name {background: #992667;}

      @media (max-width: 768px) {
        box-shadow: none !important;
        .card-name {
          background: transparent !important;
        }
        .card-img img {transform: scale(1.05);}
      }
    }
  }
  .related-arrow {
    width: 60px;
    height: 60px;
    border: none;
    background: rgba(49, 47, 47, 0.96);
    color: #fff;
    font-size: 35px;
    cursor: pointer;
    z-index: 2;
    &:hover {background: #992667;}
    &:disabled {opacity: 0.3;cursor: not-allowed;}

    @media (max-width: 768px) {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 99;
      width: 36px !important;
      height: 36px !important;
      font-size: 20px !important;

      &.left { left: 0; }
      &.right { right: 0; }
    }
  }
}

/* ====================== 移动端单独优化（只改样式，不动逻辑） ====================== */
@media (max-width: 768px) {
  /* 1. 产品大图左右箭头放大 */
  .detail-big-img .img-arrow {
    width: 40px !important;
    height: 40px !important;
    font-size: 25px !important;
  }

  /* 2. 产品名称放大 */
  .detail-name {
    font-size: 30px !important;
    margin: 20px 0 !important;
  }

  /* 3. GET A QUOTE 按钮放大 */
  .quote-btn {
    padding: 10px 22px !important;
    font-size: 14px !important;
  }

  /* 4. 缩略图区域放大 */
  .thumb-control .thumb-btn {
    width: 20px !important;
    height: 140px !important;
    font-size: 30px !important;
  }
  .thumb-item {
    width: 48px !important;
    height: 65px !important;
  }

  /* 5. 所有标签标题文字放大 */
  .tab-item,
  .section-title {
    font-size: 14px !important;
  }

  /* 6. 相关产品左右箭头放大 */
  .related-arrow {
    width: 40px !important;
    height: 40px !important;
    font-size: 25px !important;
  }

  .param-item,
  .params-image-vertical + div,
  .text-params div,
  .params-section > div {
    font-size: 13px !important;
    line-height: 1.8 !important;
  }

  .quote-header h3 {font-size: 20px;}
  .quote-header p {font-size: 14px;}
  .form-item label {font-size: 14px;}
  .form-item input, .form-item textarea {padding: 10px 12px;font-size: 14px;}
  .submit-btn {padding: 10px 28px;font-size: 15px;}
  .close-btn {
    top: 25px !important;
    right: 25px !important;
    width: 36px !important;
    height: 36px !important;
    font-size: 30px !important;
    line-height: 36px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
  .char-count {font-size: 14px !important;}
  .error-tip {font-size: 12px !important;}
  .el-message {font-size: 15px !important;}
}
.img-preview-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.95);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  box-sizing: border-box;
}
.img-preview-box {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* 关闭按钮 */
.preview-close {
  position: absolute;
  top: 1px;
  right: 1px;
  font-size: 42px;
  color: #fff;
  cursor: pointer;
  user-select: none;
  z-index: 999999;
  &:hover {
    color: #992667;
  }
  @media (max-width: 768px) {
    color: #992667;
  }
}

/* 主体布局：左大图 + 右缩略图 */
.preview-main {
  display: flex;
  align-items: center;
  width: 100%;
  height: 96vh; /* 大图高度占满屏幕，留少量边距 */
  gap: 16px;
}

/* 左侧大图 */
.preview-big {
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  img {
    max-width: 100%;
    max-height: 100%; /* 高度撑满容器 */
    object-fit: contain;
  }
}
.preview-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  border: none;
  background: rgba(104, 103, 103, 0.5);
  color: #fff;
  font-size: 28px;
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.2s;
  z-index: 10;
  opacity: 1;
  visibility: visible;
  &:hover {
    background: #992667;
  }
  &.prev {
    left: 15px;
  }
  &.next {
    right: 15px;
  }
}

/* 右侧缩略图容器（竖向） */
.preview-thumb-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  gap: 8px;
}
.thumb-arr {
  width: 40px;
  height: 40px;
  border: none;
  background: rgba(255,255,255,0.2);
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  border-radius: 4px;
  &:hover {
    background: #992667;
  }
}
/* 竖向缩略图列表 */
.preview-thumb {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
  padding: 4px;
}
.preview-thumb-item {
  width: 90px;
  height: 100px;
  flex-shrink: 0;
  border: 2px solid transparent;
  cursor: pointer;
  border-radius: 4px;
  overflow: hidden;
  opacity: 0.7;
  transition: all 0.2s;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &.active,
  &:hover {
    border-color: #992667;
    opacity: 1;
  }
}

/* 移动端适配：缩略图改回底部横向，保证体验 */
@media (max-width: 768px) {
  .preview-main {
    flex-direction: column;
    height: 92vh;
  }
  .preview-thumb-wrap {
    width: 100%;
    height: auto;
    flex-direction: row;
  }
  .preview-thumb {
    flex-direction: row;
    overflow-x: auto;
    overflow-y: hidden;
    width: 100%;
  }
  .preview-close {
    font-size: 32px;
  }
  .preview-arrow {
    width: 36px;
    height: 36px;
    font-size: 20px;
    background: rgba(0, 0, 0, 0.5);
    opacity: 1;
    visibility: visible;
  }
  .preview-thumb-item {
    width: 65px;
    height: 75px;
  }
  .thumb-arr {
    width: 32px;
    height: 32px;
    font-size: 16px;
  }
}
</style>

<style lang="scss">
@media (max-width: 768px) {
  .el-message .el-message__content {
    font-size: 16px !important;
  }
}

</style>